import PlaneIcon from '@app/assets/icons/plane.svg?react';

interface ScheduleItem {
  start: string;
  campaignId: string;
  campaignName?: string;
  description?: string;
  customerCount?: number;
}

interface DashboardFollowUpItemProps {
  schedule: ScheduleItem;
  onClick?: () => void;
}

export const DashboardFollowUpItem = ({
  schedule,
  onClick,
}: DashboardFollowUpItemProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString + 'T00:00:00'); // Ensure we're working with local time
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for accurate comparison

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const scheduleDate = new Date(date);
    scheduleDate.setHours(0, 0, 0, 0);

    if (scheduleDate.getTime() === today.getTime()) {
      return 'Today';
    } else if (scheduleDate.getTime() === tomorrow.getTime()) {
      return `Tomorrow, ${date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })}`;
    } else {
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    }
  };

  const getScheduleDescription = () => {
    if (schedule.description) {
      return schedule.description;
    }

    // Generate description based on campaign type
    const customerText = schedule.customerCount
      ? `for ${schedule.customerCount} customer${schedule.customerCount === 1 ? '' : 's'}`
      : '';
    return `Automatic resending of the "${schedule.campaignName || 'Email subject'}" campaign ${customerText}`;
  };

  return (
    <div
      className="p-3 sm:p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-start gap-2 sm:gap-3">
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
            <PlaneIcon className="w-4 h-4 text-gray-600" />
          </div>
        </div>

                  <div className="flex-1 min-w-0">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-2">
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900">
                  {formatDate(schedule.start)}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {getScheduleDescription()}
                </p>
              </div>
              <div className="flex-shrink-0">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onClick?.();
                  }}
                  className="px-2 sm:px-3 py-2 sm:py-3 rounded-lg bg-base-ghostWhite text-base-blue disabled:opacity-50 text-xs w-full sm:w-auto"
                >
                  Open
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};
